import React, { useState, useEffect, useRef } from 'react';
import { Box, Grid, Paper, Typography, CircularProgress, TextField, Chip, Autocomplete, MenuItem, Checkbox, Pagination, InputAdornment } from '@mui/material';
import ApiService from "../../functions/apiService";
import moment from 'moment';
import ButtonTheme from '../../components/ThemeButton/ThemeButton';
import { toast } from 'react-toastify';
import './leavebook.css'
import ButtonDatePicker from '../../components/DatePickers/ButtonDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import MyTable from '../../components/Schedule/MyTable';

const columns = [
	{
		field: 'Shift_Date', headerName: 'Date', flex: 1, minWidth: 120,
		valueGetter: (params) => { return moment(params?.row?.Shift_Date).format('MM/DD/YY') }
	},

	{
		field: 'Shift', headerName: 'Shift', flex: 1, minWidth: 120,
		renderCell: (params) => {
			return (
				<Chip style={{ width: '60px' }}
					label={params?.row?.Shift}
					className={params?.row?.Shift == 'Day' ? 'day-chip' : 'night-chip'} />
			)
		}
	},

	{
		field: 'Group', headerName: 'Group', flex: 1, minWidth: 80,
		renderCell: (params) => {
			return (
				<div className='group-chip'>
					{params?.row?.Group}
				</div>
			)
		}
	},

	{
		field: 'Member', headerName: 'Members (up to 5)', flex: 1, minWidth: 850,
		renderCell: (params) => {

			const employees = params?.row?.Employees || [];
			const employeeCount = employees.length;

			let boxCount = 5 - employeeCount;

			return (
				<div style={{ display: 'flex', gap: '15px' }}>
					{params?.row?.Employees.map((a) => (
						<div
							style={{
								height: '30px',
								width:'150px',
								display: 'flex',
								marginTop:'6px',
								alignItems: 'center',
								whiteSpace: 'normal',
    						wordBreak: 'break-word'
							}}>
							{a?.EA_Rank + " " + a?.First_name + " " + a?.Last_name}
						</div>
					))}

					{Array.from({ length: boxCount > 0 ? boxCount : 0 }).map((_, idx) => (
						<div
							key={`box-${idx}`}
							style={{
								width: '150px', 
								height: '40px',
								background: '#eeeeee',
								borderRadius: '25px',
							}}
						/>
					))}

				</div>
			)
		}
	}
]

const LeaveBook = () => {
	const [leaveBookData, setLeaveBookData] = useState([]);
	const [loading, setLoading] = useState(false);
	const [searchResult, setSearchResult] = useState('');
	const [date, setDate] = useState(moment(new Date()).format('MM/DD/YYYY'))
	const [employees, setEmployees] = useState([])
	const [empCode, setEmpCode] = useState('ALL')
	const [groups, setGroups] = useState([])
	const [groupCode, setGroupCode] = useState('ALL')

	const getLeavebook = (loader = true) => {
		const body = {
			"Shift_Date": moment(date).format('YYYY/MM/DD'),
			"Group_Code": groupCode,
			"Emp_Code": empCode
		}

		if (loader) {
			setLoading(true)
		}
		ApiService.post('/getLeaveBookList', body)
			.then(({ data }) => {
				const formattedData = data?.map((item, index) => ({
					...item,
					id: index
				}));

				setLeaveBookData(formattedData);
				setLoading(false);
			})
			.catch((e) => {
				setLoading(false);
			})
	}

	const loadEmployees = () => {
		setLoading(true);
		ApiService.get('/getLeaveBookEmployees')
			.then(({ data }) => {
				var tempArr = []
				data.data.map((emp) => {
					var obj = {
						label: emp.Name,
						value: emp.Emp_Code
					}
					tempArr.push(obj)
				})
				setEmployees(tempArr)
				setLoading(false);
			})
			.catch((e) => {
				setLoading(false);
			})
	}

	const loadGroups = () => {
		setLoading(true);
		ApiService.get('/getLeaveBookGroups')
			.then(({ data }) => {
				var tempArr = []
				data.data.map((grp) => {
					var obj = {
						label: grp.group,
						value: grp.id
					}
					tempArr.push(obj)
				})
				setGroups(tempArr)
				setLoading(false);
			})
			.catch((e) => {
				setLoading(false);
			})
	}

	useEffect(() => {
		getLeavebook()
		loadEmployees()
		loadGroups()
	}, [])

	return (
		<Paper>
			<Grid container className='align-items-center' gap={2} style={{ gap: "24px" , paddingTop:'24px' , paddingLeft:'16px' , paddingRight:'16px' , marginTop:'10px'}} >
				<Grid xs={12} sm={12} md={4}>
					<Typography variant="h5">Leave Book</Typography>
				</Grid>

				<>
					{/* Date Picker */}
					<Grid items xs={12} sm={12} md={2} className='d-grid'>
						<div>
							<LocalizationProvider dateAdapter={AdapterDateFns}>
								<ButtonDatePicker
									className='w-100'
									label={moment(date).format('MM-DD-YYYY')}
									value={new Date(date)}
									onChange={(e) => {
										setDate(moment(e).format('YYYY-MM-DD'))
									}}
								/>
							</LocalizationProvider>
						</div>

					</Grid>

					{/* Select Group */}
					<Grid items xs={12} sm={12} md={2} className='font-fam'>
						<Autocomplete
							options={groups}
							onChange={(event, newValue) => { setGroupCode(newValue?.value) }}
							renderInput={(params) => (
								<TextField
									{...params}
									label="Select Group"
									placeholder="Select Group"
									color="secondary"
									variant="outlined"
									fullWidth
									size="small"
									sx={{
										"& .MuiInputBase-root": {
											height: "48px",
											fontSize: "1rem",
											display: "flex",
											alignItems: "center",
											justifyContent: "center"
										},
										"& .MuiFormLabel-root": {
											marginTop: "4px"
										},
										"& .MuiInputLabel-shrink": {
											marginTop: "0px"
										}
									}}/>
							)}
						/>
					</Grid>

					{/* Select Employee */}
					<Grid item xs={12} sm={12} md={2}>
						<Autocomplete
							options={employees}
							onChange={(event, newValue) => { setEmpCode(newValue?.value) }}
							renderInput={(params) => (
								<TextField
									{...params}
									label="Select Employee"
									placeholder="Select Employee"
									color="secondary"
									variant="outlined"
									fullWidth
									size="small"
									sx={{
										"& .MuiInputBase-root": {
											height: "48px",
											fontSize: "1rem",
											display: "flex",
											alignItems: "center",
											justifyContent: "center"
										},
										"& .MuiFormLabel-root": {
											marginTop: "4px"
										},
										"& .MuiInputLabel-shrink": {
											marginTop: "0px"
										}
									}}/>
							)}
						/>
					</Grid>

					<Grid item xs={10} md={"auto"}>
						<div>
							<ButtonTheme type='submit' variant="filled" color='primary' onClick={() => { getLeavebook() }} style={{ height: 38 }}>
								Refresh
							</ButtonTheme>
						</div>
					</Grid>
				</>
			</Grid>
			{loading ? (
			<div className="w-100 h-100 d-flex justify-content-center align-items-center py-5">
				<CircularProgress />
			</div>
		) :
			(
				<div className="px-3">
					{leaveBookData?.length == 0 ?
						<div className='d-flex flex-column align-items-center justify-content-center' style={{ height: 595 }}>
							<img src='/images/blur-logo.png' style={{ height: 200, width: 250 }} />
							<span className='mt-4' style={{ color: '#555555' }}>
								No Leaves Found
							</span>
						</div>
						:
						<div className='mt-4'>
							<MyTable
								rows={leaveBookData}
								columns={columns}
								checkboxSelection={false}
								hideFooter={leaveBookData.length > 100 ? false :  true}
								rowCount={leaveBookData.length}
								perPage={100}
							/>
						</div>}
				</div>
			)
		}
		</Paper>
	)
}

export default LeaveBook;